import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {popupEdit_template} from "../components/templates/popupEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class popup_edit extends vnModule_knockoutJS{
    protected popupEdit : popupEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdlCaller: string;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.popupEdit = new popupEdit_template('popupEdit', this.viewModel, this)
        return [this.popupEdit.build()]
    }

    protected getModuleName(): string {
        return "popup_edit";
    }

    public fillPage() {
        this.getPopupDataForEdit()
    }

    private getPopupDataForEdit() {
        this.loadingIn(this.popupEdit.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/popup/get/edit/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetPopupDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetPopupDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let popup = responseParsed.data
                let availableSignupForms = responseParsed.availableSignupForms
                obj.setPopupData(popup, availableSignupForms);

            });
            obj.loadingOut(obj.popupEdit.builtTemplate);
        }
    }

    protected setPopupData(popup, availableSignupForms) {
        this.popupEdit.generateDropzone(this.getVnAppZone().app.params.idBrand)
        this.popupEdit.setId(popup.id)
        this.popupEdit.setIsEnabled(popup.isEnabled)
        this.popupEdit.setHeadline(popup.headline)
        this.popupEdit.setDescription(popup.description)
        this.popupEdit.setImage(popup.image)
        if(popup.signupForm) {
            this.popupEdit.setSignupForm(popup.signupForm.id)
        }
        this.popupEdit.setGeos(popup.geos);
        this.popupEdit.setPageDepth(popup.pageDepth)
        this.popupEdit.setAvailableSignupForms(availableSignupForms)
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/popups/")
    }

    protected save() {
        this.loadingIn(this.popupEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/popup/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/popups/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Popup saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }
                });
                obj.loadingOut(obj.popupEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected getSuggestions(keyword, idSourceElement) {
        this.XHRHdlCaller = "getSuggestions_" + idSourceElement;

        if (idSourceElement == "filterAutocompleteGEO_template") {
            this.getGeoSuggestion(keyword, idSourceElement);
        }
    }

    public getGeoSuggestion(keyword, idElement) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {filter: {keyword: keyword},  idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/popup/search/geo/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){
                let response = JSON.parse(req.request.response);

                if (obj.XHRHdlCaller == "getSuggestions_filterAutocompleteGEO_template") {
                    obj.popupEdit.filterGEO.setOptions(response.data.availableGeos);
                }
            });
        }
    }

    protected onAutocompleteInputClick(idElement) {

    }

    protected onAutocompleteOptionChange(idElement) {

        if (idElement == "filterAutocompleteGEO_template"){
            let geos = this.popupEdit.getTemplateViewModel().geos();
            let chosenGeo = this.popupEdit.filterGEO.getTemplateViewModel().optionObj();
            let duplicateGeo = false;

            for (let geo of geos) {
                if (geo.id === chosenGeo.id) {
                    duplicateGeo = true;
                    break;
                }
            }

            if (!duplicateGeo) {
                geos.push(chosenGeo);
                this.popupEdit.getTemplateViewModel().geos(geos);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/popup_edit.ts